module.exports = function() {
  return new Worker(__webpack_public_path__ + "67a87972b71b4b7acd79.worker.js");
};